import Routes from "../../../inc/Routes";

// Прокси группы — раздел «Прокси» с готовым фильтром (proxy_group_id из URL, см. useListFilters).
export const groupProxiesUrl = (groupId) =>
    `${Routes.parseName('proxies.index')}?proxy_group_id=${encodeURIComponent(groupId)}`;

// Срок группы (YYYY-MM-DD после ProxyGroupFormatter) → «31.10.2026»; нет срока — «без срока».
export function formatGroupDate(date) {
    return date ? date.split('-').reverse().join('.') : 'без срока';
}
